<script>
  import { Button, Badge, DropdownList, DropdownItem, Flex, Icon } from "@gl/design-system"
  import { faDoNotEnter } from "@fortawesome/pro-solid-svg-icons"
  import { _ } from "../stores/index"
  export let id
  export let clearAllLabel = "Clear all"
  export let noResultsLabel = "No results"
  export let placeholder = "Type something"
  export let readonly = false
  export let options = []
  export let value
  export let label
  export const inline = false
  export let tagColor

  let inputListWidth = 0
  let isFocused
  let searchValue = ""
  let choices = []

  let filteredOptions
  $: if (searchValue === "") {
    filteredOptions = options.filter((option) => !choices.includes(option))
  } else {
    filteredOptions = options.filter(
      (option) => option.label.toLowerCase().includes(searchValue.toLowerCase()) && !choices.includes(option)
    )
  }

  const clickOutside = (node) => {
    const handleClick = (event) => {
      if (node && !node.contains(event.target) && !event.defaultPrevented) {
        node.dispatchEvent(new CustomEvent("click_outside", node))
      }
    }

    document.addEventListener("click", handleClick, true)
    return {
      destroy() {
        document.removeEventListener("click", handleClick, true)
      },
    }
  }

  $: if (value) {
    choices = value
  }
</script>

<div
  class:is-focused={isFocused}
  use:clickOutside
  on:click_outside={() => {
    isFocused = false
  }}
  {id}
  class="gl-autocomplete"
>
  <div class="gl-autocomplete-search" class:readonly>
    {#if !readonly}
      <div class="gl-autocomplete-input-list" bind:clientWidth={inputListWidth}>
        {#if label}<p class="mr-4">{label}: {choices.length}</p>{/if}

        <input
          class="gl-autocomplete-input"
          type="text"
          {placeholder}
          bind:value={searchValue}
          on:focus={() => (isFocused = true)}
        />

        {#if inputListWidth > 376}
          <div class="gl-autocomplete-button">
            <Button
              size="tiny"
              outlined
              on:click={() => {
                filteredOptions = options
                choices = []
                value = choices
              }}>{clearAllLabel}</Button
            >
          </div>
        {/if}
      </div>
    {/if}

    <div class:mt-5={isFocused} class="gl-autocomplete-list mt-2">
      {#each choices as item}
        <Badge
          label={item.label}
          bold
          close={!readonly && !item.disabled}
          on:close={() => {
            filteredOptions.push(item)
            filteredOptions = filteredOptions.sort()
            choices = choices.filter((choice) => choice !== item)
            value = choices
          }}
          class={`background-color-${tagColor}`}
        />
      {/each}
    </div>
  </div>

  <div class="gl-autocomplete-results">
    <div class="gl-autocomplete-dropdown">
      <DropdownList opened>
        {#each filteredOptions || options as item}
          {#if !value || !value.some((v) => v.value === item.value)}
            <DropdownItem selectable={false}>
              <button
                disabled={item.disabled}
                class="mb-1"
                class:is-disabled={item.disabled}
                on:click={(e) => {
                  e.preventDefault()
                  choices.push(item)
                  choices = choices
                  filteredOptions = options.filter((option) => !choices.includes(option))
                  searchValue = ""
                }}
              >
                <Flex>
                  {item.label}
                  {#if item.disabled}
                    <div class="ml-3">
                      <Icon icon={faDoNotEnter} class="is-disabled" />
                      <span class="is-disabled">{$_("missing.policies.autocomplete")}</span>
                    </div>
                  {/if}
                </Flex>
              </button>
            </DropdownItem>
          {/if}
        {:else}
          <DropdownItem>
            <span>{noResultsLabel}</span>
          </DropdownItem>
        {/each}
      </DropdownList>
    </div>
  </div>
</div>

<style>
  .is-disabled {
    color: var(--gl-text-disabled);
    pointer-events: none;
  }
</style>
